import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

const eventsDiv = document.getElementById('asc-events');
const hostedDiv = document.getElementById('asc-hosted-events');
const communityDiv = document.getElementById('asc-community-events');
if (eventsDiv) {
  ReactDOM.render(
    <App count={eventsDiv.getAttribute('data-count')} />,
    eventsDiv
  );
}
if (hostedDiv) {
  ReactDOM.render(
    <App list='hosted' count={hostedDiv.getAttribute('data-count')} />,
    hostedDiv
  );
}
if (communityDiv) {
  ReactDOM.render(
    <App list='community' count={communityDiv.getAttribute('data-count')} />,
    communityDiv
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
